export function IsLocalHost() {
  return (
    window.location.href.includes('localhost') ||
    window.location.href.includes('127.0.0.1') ||
    window.location.href.includes('192.168') ||
    window.location.href.includes('local.app.livelinx.com')
  );
}
